import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-account-greenness-notification-modal',
  templateUrl: './account-greenness-notification-modal.component.html',
  styleUrls: ['./account-greenness-notification-modal.component.scss'],
  standalone: false
})
export class AccountGreennessNotificationModalComponent {
  @Input() success: boolean;

  constructor(private modalController: ModalController) {}

  close() {
    this.modalController.dismiss();
  }
}
